// extracted by mini-css-extract-plugin
export default {"profileLabel":"UpmeProfileUpdateInfo_profileLabel__DsmZ5","profileDetails":"UpmeProfileUpdateInfo_profileDetails__scgGJ","info":"UpmeProfileUpdateInfo_info__LfNT5"};